export default __webpack_public_path__ + "static/media/trash.b4058dc9.svg";